<template>
        <div>          
            <GroupGL
                ref="menu_group"
                :top="PositionY"
                :left="store.width / 100 * 5"
                :x="x"
                :y="0"
                :scale="scaleMenu">

                <TextFontGroup 
                    ref="items"
                    :top="0"
                    :left="0"
                    :x="0"
                    :y="0"
                    :active="isActive"
                    :currentState="currentState"
                    :url="`/directors`"
                    :isResizing="true"
                    :isSelected="$route.matched[0].name.indexOf('directors') !== -1">
                    <TextFontAnim
                        text="DIRECTORS" 
                        :top="0"
                        :duration="duration"
                        :left="0"
                        :letter-spacing="letterSpacing"
                        :font-size="fontSize"
                        :opacityDuration="0.3"
                        :behavior="behavior">
                    </TextFontAnim>
                </TextFontGroup>
                <TextFontGroup 
                    ref="items"
                    :top="state.lineHeight * fontSize * 0.95"
                    :left="0"
                    :x="0"
                    :y="0"
                    :active="isActive"
                    :isResizing="true"
                    :currentState="currentState"
                    :url="`/about`"
                    :isSelected="$route.matched[0].name.indexOf('about') !== -1">
                    <TextFontAnim
                        text="ABOUT" 
                        :top="0"
                        :left="0"
                        :duration="duration"
                        :opacityDuration="0.3"
                        :letter-spacing="letterSpacing"
                        :font-size="fontSize"
                        :behavior="behavior">
                    </TextFontAnim>
                </TextFontGroup>

                <TextFontGroup 
                    ref="items"
                    :top="state.lineHeight * fontSize * 2 * 0.95"
                    :left="0"
                    :x="0"
                    :y="0"
                    :active="isActive"
                    :isResizing="true"
                    :currentState="currentState"
                    :url="`/news`"
                    :isSelected="$route.matched[0].name.indexOf('news') !== -1">
                    <TextFontAnim
                        text="NEWS" 
                        :top="0"
                        :left="0"
                        :opacityDuration="0.3"
                        :duration="duration"
                        :letter-spacing="letterSpacing"
                        :font-size="fontSize"
                        :behavior="behavior">
                    </TextFontAnim>
                </TextFontGroup>
            </GroupGL>
        </div>
</template>

<script>

import Store from '@/stores/store.js'
import TweenMax from "gsap/TweenMax";
import TextFontAnim from '@/components/TextFontAnim.vue'
import GroupGL from '@/components/GroupGL.vue'
import TextFontGroup from '@/components/TextFontGroup.vue'
import FontTransitions from '@/views/GL/FontTransitions.js'
import ControllerGUI from '@/utils/ControllerGUI'

export default {

    name: 'Menu',
    components:{
        TextFontAnim,
        GroupGL,
        TextFontGroup
    },
    data() {
        return {
            store: Store,
            state: Store.state,
            x: 0,
            duration: ControllerGUI.Menu.fontDuration,
            behavior: {
                mobile: 'Mobile_Condensed',
                state0:{
                    hover: 'Bold_to_Light' // Transition au hover
                },
                state0to1: {
                    selected: 'NormalWide_to_ThinCondensed', //Transtion de l'état final du hover (en state0) à l'état selected (en state1)
                    notselected: 'BoldWide_to_LightCondensed' //Transtion de l'état normal (en state0) à l'état notselected (en state1)
                },
                state1to0: {
                    selected: 'BoldWide_to_LightCondensed_Reverse', //Transition de l'état selected (en state1) à l'état normal (en state0)
                     notselected: 'Bold_to_Light'
                },
                state1: {
                    hover: 'LightCondensed_to_ThinCondensed', //Transition de normal(/notselected) à l'état hover(/selected)
                    hoverselected: 'LightCondensed_to_ThinCondensed' //Transition de normal(/notselected) à l'état hover(/selected)
                }
            },
            transition: [Power3.easeIn, Power3.easeOut, Power3.easeInOut]
        }
    },
    computed:{
        PositionY() {
            // Gets top position for the menu according to devices
            if( this.store.isDesktop ) return (this.store.height - (this.state.lineHeight * this.fontSize * 3) + this.vw(4)) * 1.05;
            else if(this.store.isTablet) {
                if(Store.height > Store.width) {
                    return (this.store.height - (this.state.lineHeight * this.fontSize * 3) + this.vw(12)) * 1.05;
                }
                else {
                    return (this.store.height - (this.state.lineHeight * this.fontSize * 3) + this.vw(6)) * 1.05;
                }
            }
            else return (this.store.height - (this.state.lineHeight * this.fontSize * 3) + this.vw(12));
        },
        isActive() {
            // Deactivate the hover for state 2 and above
            if( this.state.level < 1  ) return true
            else return false
        },
        fontSize(){
            //returns the font size 
            if( this.store.isDesktop){
                return this.vw(0.080);
            }
            else if(this.store.isTablet) {
                if(Store.height > Store.width) {
                    return this.vw(0.18);
                }
                else {
                    return this.vw(0.1);
                }
            }
            else return this.vw(0.18);
        },
        letterSpacing() {
            // Sets the letterspacing
            if( this.store.isDesktop )  return -8  
            else return 0;
        },
        scaleMenu(){
            // Scla of the menu when in differents state 
            if(this.state.level == 0) return 1 // Usual size
            else if(this.state.level == 1) return 0.6 // Smaller size 
            else return 0.35 // Even smaller
        },

        scaleBackzone() {
            // Deprecated, used for the backzone 
            if(this.state.level == 0) return 0
            else if(this.state.level == 1) return 1
            else return 0.7
        },
        currentState(){
            //reutns the current state for the font transition
            return this.state.level == 0 ? 0 : 1;
        },
        absoluteState(){
            return this.state.level;
        },
        notFound() {
            return this.store.state.notFound
        }
    },
    methods: {
        transitionLeft() {
            if(this.absoluteState > 0 && this.store.isMobile) {
                 setTimeout(() => {  
                    TweenMax.to(this, 0.4, {x: -this.store.width, ease: Power3.easeOut
                    });
                 }, 250);
            }
            else if(this.store.state.notFound) {
                TweenMax.to(this, 0.4, {x: -this.store.width, ease: Power3.easeOut
                    });
            }
            else {
                 setTimeout(() => {
                    TweenMax.to(this, 0.8, {x: 0, ease: Power3.easeOut
                    });
                 }, 200);
            }
        },
        enterAnimation() {
            this.$refs.menu_group.$children.forEach((element, index) => {
                element.enterFontTransition(1)
            });
        },
        updateDuration() {
            this.duration = ControllerGUI.Menu.fontDuration
        }
    },
    created() {
        this._updateDuration = this.updateDuration.bind(this)
    },

    mounted() {
        ControllerGUI.MenuGUI(this._updateDuration)
        this.transitionLeft();
        if(this.state.level == 0 && this.store.isDesktop) { 
            setTimeout(() => {
                this.enterAnimation(); 
            }, 250); 
            Store.state.init = false
        }
        this.$forceUpdate();
    },

    watch: {
        absoluteState: function(){
            this.transitionLeft()
        },
        notFound: function(){
            this.transitionLeft()
        },
    }
}
</script>

<style lang="scss" scoped>
.Menu-backzone {
    height: 50vh;
    width: 25%;
    position: absolute;
    z-index: 1000;
    background: rgba(255,0,0,0);
    cursor: default;
}
</style>